<template>
  <div>
    <header-navigation></header-navigation>
    <article-header></article-header>
    <pageloader v-if="pageload" />
    <div class="blog-post-container container">
      <div class="blog-post" v-for="(data, index) in content" :key="index">
        <router-link
          :to="'/' + $route.params.region + '/support/' + data.post_name"
        >
          <h3 class="title heading-lg">
            {{ data.post_title }}
          </h3>
          <p class="excerpt text-xs" v-if="data.post_excerpt">
            {{ data.post_excerpt }}
          </p>
        </router-link>
      </div>
    </div>

    <footer>
      <nav class="company-pages px-3 px-md-0">
        <div class="container">
          <div class="">
            <footer-navigation
              v-bind:category="'quick-links'"
            ></footer-navigation>
          </div>
          <hr class="d-none d-md-block" />

          <div class="row">
            <div class="col-lg-8 my-5 mt-md-0 my-lg-0">
              <footer-navigation
                v-bind:category="'useful-links'"
              ></footer-navigation>
            </div>

            <div class="col-lg-4">
              <social-media></social-media>
              <div class="copyright-disclaimers d-none d-md-block">
                <p><span>© ResMed</span> {{ $getTranslation("All rights reserved.", $route.params.region) }}</p>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </footer>
  </div>
</template>

<script>
// import jsonData from "./assets/data-blog.json";
// import group from "./components/navigation/group.vue";
import headerNavigation from "./components/navigation/header.vue";
import footerNavigation from "./components/navigation/footer.vue";
import articleHeader from "./components/navigation/articles-blog-header.vue";
import Pageloader from "./components/shared-support/pageloader.vue";
import wpApi from "./services/wpApi";

export default {
  components: { headerNavigation, footerNavigation, articleHeader, Pageloader },
  data() {
    return {
      content: {},
      pageload: true,
    };
  },
  name: "Blog",
  created() {},
  async mounted() {
    try {
      const data = await wpApi.listAllArticles(this.$route.params.region);
      this.pageload = false;
      this.content = data.data;
      this.pageNotFound(data.data.length);
    } catch (e) {
      this.pageNotFound();
    }
  },
  methods: {
    pageNotFound(data) {
      if (data == 0) {
        this.$router.push({
          name: "404",
          params: {
            region: this.$route.params.region,
            slug: "-page-sleep-apnea",
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.blog-post-container {
  display: grid;
  grid-template-columns: auto auto auto;
  grid-gap: 20px;
  justify-content: center;
  margin: 40px auto;

  @media (max-width: 767px) {
    grid-template-columns: auto;
  }
}

.blog-post {
  padding: 1.75rem;
  border: 1px solid #f4f4f4;
  background: #ffffff;
  box-shadow: -1px 0.25rem 12px 2px rgb(0 0 0 / 13%);

  h3 {
    font-size: clamp(14px, 18px, 20px);
    font-family: "Plus Jakarta Sans", sans-serif;
    font-weight: 500;
    color: #2c2a2a;
  }

  p {
    font-family: "Plus Jakarta Sans", sans-serif;
    font-weight: 500;
    font-size: clamp(12px, 16px, 18px);
    color: #2c2a2a;
  }
}
</style>
